import React, { useState , useEffect } from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import LeftArrow from '../../../Assets/images/DFL/landing-page-img/left-arrow.png'
import RightArrow from '../../../Assets/images/DFL/landing-page-img/right-arrow.png'
import Slider from 'react-slick'
import { NavLink, useHistory } from 'react-router-dom'
import { base_url } from '../../../Helpers/request'

const TrendingNow = () => {
   const history = useHistory
   const [trendingData ,setTrendingData] = useState([]);

   useEffect(() => {
      getData() 
   },[])

   const getData = async() => {
     try{
     const response = await fetch(base_url + "/Common/trendingjewellry");
     const data = await response.json();
      setTrendingData(data.data)
     }catch(err){
        console.log(err)
     }
   }


    const trendingnow = {
        dots: false,
        infinite: true,
        speed: 500,
        prevArrow: <img src={LeftArrow} />,
        nextArrow: <img src={RightArrow} />,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className='dfl_eng_Shop_ring_by_style_section'>
            <Container className='dfl_custome_container_staticpage'>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <div>
                            <div class="title-box2 text-center border-title mb-0">
                                {/* <img src={LineImg2} alt="line_2" /> */}
                                <h2 class="title24 title-box2 dark">Trending Now</h2>
                                {/* <img src={LineImg3} alt="line_3" /> */}
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <div className='dfld_shap_slider'>
                            <Slider {...trendingnow} className="dfld_explore_diamond_shap_slider">
                                {trendingData.map((val, index) => (
                                    <NavLink className='dfld_img_shap_box_outer'to={val.category_id == 2 ? "/ringsettingdetail/setting/" + val.slug: "/productdetail/" + val.slug}>
                                        <div key = {index} className='dfld_img_shap_box_inner dfl_eng_ring_img'>
                                            <Image src={val.product_image} alt={val.name}/>
                                            <h4>{val.name}</h4>
                                        </div>
                                    </NavLink>
                                ))} 
                            </Slider>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default TrendingNow